<loading class="tw-absolute tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
         *ngIf="loading"></loading>
<div class="tw-block tw-w-full tw-h-screen tw-font-lexend tw-bg-white tw-flex tw-flex-col" *ngIf="!loading">
  <div class="tw-shrink-0 tw-px-4 tw-pt-4 tw-relative tw-flex tw-items-center tw-justify-center">
    <div class="tw-absolute tw-left-4 tw-h-10 tw-w-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-rounded-xl"
         (click)="back()">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-white"
               [iconName]="'arrow_back'"></cs-icon>
    </div>
    <span class="tw-font-lexend tw-font-bold tw-text-400 tw-text-gray-800"
          i18n="@@outgoingCallFeedback">Call Feedback</span>
  </div>

  <div class="tw-flex-1 tw-px-4 tw-pt-6 tw-flex tw-flex-col tw-items-center tw-overflow-y-auto tw-w-full" >
    <div class="tw-w-full tw-p-4 tw-border tw-rounded-xl tw-bg-white tw-shadow-z1">
      <p class="tw-font-lexend tw-text-500 tw-font-bold tw-text-gray-800 tw-text-center tw-mb-6"
         i18n="@@rateYourCallExperience">
        How would you rate your call experience?
      </p>

      <div class="tw-flex tw-items-center tw-justify-center tw-w-full tw-max-w-[400px] tw-flex-wrap tw-mx-auto">
        <div class="tw-flex tw-items-center tw-px-3 tw-justify-between tw-w-full tw-mb-1">
          <span class="tw-font-body tw-text-100 tw-uppercase tw-tracking-wide tw-text-gray-500"
                i18n="@@notLikely">Not likely</span>
          <span class="tw-font-body tw-text-100 tw-uppercase tw-tracking-wide tw-text-gray-500"
                i18n="@@extremelyLikely">Extremely likely</span>
        </div>
        <div class="tw-flex tw-flex-nowrap tw-items-center">
          <div class="tw-border tw-border-gray-200 tw-h-20 tw-pt-6"
               *ngFor="let rating of ratingArray; let i = index"
               [ngClass]="i === 0 ? 'tw-border-l' : 'tw-border-l-0'"
               [style.backgroundColor]="getRatingBgColor(i)"
               (click)="selectRating(i)">
            <cs-icon [iconName]="rating"></cs-icon>
            <div class="tw-m-auto tw-font-body tw-text-200 tw-text-center"
                 [ngClass]="isSelected(i) ? 'tw-font-bold tw-text-gray-900' : 'tw-text-gray-600'">{{i}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-w-full tw-mt-4 tw-p-4 tw-border tw-rounded-xl tw-bg-white tw-shadow-z1">
      <label class="tw-font-lexend tw-text-300 tw-text-gray-700 tw-mb-2 tw-block"
             i18n="@@additionalComments">Additional Comments</label>
      <textarea class="tw-w-full tw-resize-none tw-h-32 tw-rounded-lg tw-p-3 tw-min-h-24 tw-border tw-border-gray-200 tw-text-300 tw-font-body"
                placeholder="Tell us more about your experience..."
                [(ngModel)]="comment"
                i18n-placeholder="@@tellUsMoreAboutExperience"></textarea>
    </div>
  </div>

  <div class="tw-shrink-0 tw-bg-white tw-border-t tw-border-gray-100" >
    <div class="tw-px-6 tw-pt-3 tw-pb-5">
      <span class="tw-w-full tw-p-3 tw-flex tw-justify-center tw-items-center tw-font-bold tw-font-lexend tw-text-400 tw-rounded-3 tw-text-white shine-button tw-relative tw-overflow-hidden"
            [ngClass]="selectedRating !== null ? 'tw-bg-teal-600' : 'tw-bg-gray-400 tw-pointer-events-none'"
            (click)="selectedRating !== null && submitOutgoingCallFeedback()"
            i18n="@@submit">Submit</span>
    </div>
  </div>
</div>
